@if (loading) {
<div class="as-fixed-loader">
  <ng-lottie width="150px" height="150px" [options]="options"> </ng-lottie>
  <mat-label class="as-roboto-slab as-font-bold as-font-20 as-font-red">
    {{ 'GENERAL.loading' | translate }}...
  </mat-label>
</div>
}
<div class="as-recipe-container">
  <header>
    <p class="as-font as-font-medium as-font-16 as-font-grey-7e">
      <a [routerLink]="['/']" (click)="goRoute()" class="as-pointer">{{
        'FILTER.init' | translate
      }}</a>
      >
      <a [routerLink]="['/recetas']" (click)="goRoute()" class="as-pointer">{{
        'RECIPES.alsuperRecipes' | translate
      }}</a>
      >
      <span class="as-font-green as-font-semibold">{{
        recipe.recipe_title
      }}</span>
    </p>
  </header>

  @if (recipe) {
  <div class="as-recipe-info">
    <img [src]="recipe.recipe_image" alt="" />
    <div class="info">
      <p class="as-font-black-gray as-font-24 as-font-bold title">
        {{ recipe.recipe_title }}
      </p>
      <p class="as-font as-font-blackish as-font-16 subtitle">
        {{ recipe.recipe_description }}
      </p>
      <div class="chip" [style]="recipe.color">
        <p class="as-font as-font-14 as-font-white">
          {{ recipe.category_name }}
        </p>
      </div>
      <div class="as-times">
        <div class="cont">
          <mat-icon svgIcon="ic-hours-green"></mat-icon>
          <p class="as-font-14 as-font">{{ recipe.recipe_time }}</p>
        </div>
        <div class="cont">
          <mat-icon svgIcon="ic-money-green"></mat-icon>
          <p class="as-font-14 as-font">{{ recipe.recipe_price }}</p>
        </div>
        <div class="cont">
          <mat-icon svgIcon="ic-perfil-green"></mat-icon>
          <p class="as-font-14 as-font">
            {{ recipe.recipe_portions }} porciones
          </p>
        </div>
      </div>
    </div>
  </div>
  } @if (recipe) {
  <div class="as-recipe-process">
    <p class="as-font-16 as-font-bold as-font">
      {{ 'RECIPES.ingredients' | translate }}
    </p>
    <div class="ingredients">
      @for (item of recipe.recipe_ingredients; track item) {
      <div class="cont">
        <div class="icon-container">
          <mat-icon svgIcon="ic-checkbox-off"></mat-icon>
        </div>
        <p>{{ item }}</p>
      </div>
      }
    </div>
    <div class="container">
      <p class="as-font-16 as-font-bold as-font">
        {{ 'RECIPES.process' | translate }}
      </p>
      <div class="process">
        @for (item of recipe.recipe_preparation; track item) {
        <div class="cont">
          <div class="icon-container">
            <mat-icon svgIcon="ic-checkbox-off"></mat-icon>
          </div>
          <p>{{ item }}</p>
        </div>
        }
      </div>
    </div>
  </div>
  }
</div>
